import { ExperimentKey } from 'services/statsig/types';
import { useStatsig } from 'shared/hooks/statsig/useStatsig';

export type FundingExperimentVariant = 'control' | 'test';

export interface UseFundingExperimentResult {
  variant: FundingExperimentVariant;
}

const useFundingExperiment = (): UseFundingExperimentResult => {
  const { experimentSegmentActive } = useStatsig();
  const isTest = experimentSegmentActive(
    ExperimentKey.FUNDING_MENU_UPDATE,
    'Test',
  );
  const variant: FundingExperimentVariant = isTest ? 'test' : 'control';

  return { variant };
};

export default useFundingExperiment;
